import { render, staticRenderFns } from "./OrderCaption.vue?vue&type=template&id=19b84800&scoped=true&"
import script from "./OrderCaption.vue?vue&type=script&lang=js&"
export * from "./OrderCaption.vue?vue&type=script&lang=js&"
import style0 from "./OrderCaption.vue?vue&type=style&index=0&id=19b84800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b84800",
  null
  
)

export default component.exports